import { render, staticRenderFns } from "./AffiliationAutocomplete.vue?vue&type=template&id=6b8dde50"
import script from "./AffiliationAutocomplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./AffiliationAutocomplete.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports